import React from "react";

import "../MemberDashboard.css";
import { DashboardTab } from "../MemberDashboard";
import DashboardSidebar from "./DashboardSidebar";

type Props = {
  activeTab: DashboardTab;
  setActiveTab: (tab: DashboardTab) => void;
  showLibrary: boolean;
  children: React.ReactNode;
};

const DashboardLayout = ({
  activeTab,
  setActiveTab,
  showLibrary,
  children
}: Props) => {
  return (
    <div className="dashboard">

      <DashboardSidebar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        showLibrary={showLibrary}
      />

      <main className="dashboard-main">
        {children}
      </main>

    </div>
  );
};

export default DashboardLayout;
